import React, { useEffect } from "react";
import "./services.css";
import pergulaImage from "../../media/images/pergulaImage.png";
import porchImage from "../../media/images/porchImage.jpg";
import fenceImage from "../../media/images/fenceImage.png";
import deckImage from "../../media/images/deckImage.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

const Services = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: false, // Whether animation should happen only once
        });
    }, []);
    return (
        <section id="services">
            <h1 className="head" data-aos="fade-up">
                מה אנחנו עושים
            </h1>
            <ul>
                <li>
                    <img src={pergulaImage} alt="פרגולה שעשינו" />
                    <h2 data-aos="fade-up">פרגולות</h2>
                    <p data-aos="fade-up">
                        בעדן שלנו – ישנם אין ספור סוגים של פרגולות, העשויות
                        מחומרים שונים:
                        <span> ברזל, אלומיניום או עץ</span>.<br />
                        אנו מאמינים ש<span> פרגולה לא עושים אלא מתכננים</span> –
                        הכוונה שלכל אחד מתאימה פרגולה אחרת.
                        <br />
                        ולכן מומלץ לקבל <span>ייעוץ מקצועי</span> אשר נותן הכרות
                        עם עולם התוכן ואז תוכלו להתאים לכם את הפרגולה.
                        <br />
                        הפרגולות נועדו ליצור <span>אזור מוצל ומוגן</span> מגשם
                        בחצר, בגינה או במרפסת.
                        <br />
                        וליצור פינת רוגע ניחוחה וטבעית המעוצבת בהתאם לאופי שלכם.
                        <br />
                        אך מהכרות עם השוק ומגוון הלקוחות הרחב – אנו יודעים שיש
                        מי שמתקין פרגולה רק <span>לשם פרטיות ואווירה</span>.
                        <br />
                        <span>פרגולת הייטק</span> די נפוצה בימיינו – עשויה
                        מאלומיניום ניתן לעצב בעובי הפסים הרוחביים ואת המרווחים
                        בניהם, נתן לשלב צבעים כמובן גם תאורה, מאווררים וכו'.
                        אצלנו תוכלו לקבל הדמייה (מודל) לפני ביצוע. .
                        <br />
                        <span>פרגולה עם גג פאנלית</span> – ישנם שני סוגים
                        בעוביים שונים: פאנל מבודד מפח או מאלומיניום.
                        <br />
                        * האלומיניום הינו החומר היקר מבין כולם
                        <br />
                        * סנטף הינו יריעת פלסטיק (פוליקרבונט) שנותן את ההגנה
                        ממשקעים - יש מגוון סוגים, צבעים וכו'.
                        <br />
                        לרוב משתמשים בסנטף BH איכותי, כיוון שהוא פחות מרעיש
                        מגשם.
                    </p>
                </li>
                <li>
                    <img src={porchImage} alt="סגירת מרפסות" />
                    <h2 data-aos="fade-up">סגירת מרפסות</h2>
                    <p data-aos="fade-up">
                        סגירת מרפסת היא תהליך בו מוסיפים{" "}
                        <span>חלונות או דלתות</span> למרפסת
                        <br />
                        כדי להפוך אותה לחלל מוצק, מוזכר ומוצל.
                        <br />
                        הסגירה נעשית בדרך כלל על מנת <span>
                            להגן על המרפסת
                        </span>{" "}
                        מהאוויר, הגשמים והרוחות.
                        <br />
                        <span>החשיבות של סגירת מרפסת</span> כוללת:
                        <br />
                        <span>1. הגנה מהאלמנטים:</span> סגירת המרפסת מגנה עליה
                        מפני גשמים, רוחות וחום חורף.
                        <br />
                        <span>2. יצירת מרחב נוסף:</span> סגירת המרפסת מאפשרת
                        להוסיף מרחב פנימי נוסף לדירה או לבית.
                        <br />
                        <span>3. שיפוץ ועיצוב:</span> סגירת מרפסת מאפשרת לעצב
                        ולשדרג את המראה של המרפסת.
                        <br />
                    </p>
                </li>
                <li>
                    <img src={fenceImage} alt="גדרות" />
                    <h2 data-aos="fade-up">גדרות</h2>
                    <p data-aos="fade-up">
                        <span>גדר</span> היא מבנה או מרכוז המשמש להפרדה, הגנה או
                        הגבלת גישה בין שטחים שונים.
                        <br />
                        גדר ניתנת להקמה מחומרים שונים כגון{" "}
                        <span>עץ, מתכת, פלסטיק, קירות אבן</span>.<br />
                        <span>חשיבות של גדר בבית</span> כוללת:
                        <br />
                        <span>1. פרטיות:</span> גדר יכולה לסייע ביצירת פרטיות
                        והפרדת החללים.
                        <br />
                        <span>2. בטיחות:</span> גדר יכולה לשמש כהגנה מפני חיות,
                        גנבים או חומרים מזיקים.
                        <br />
                        <span>3. עיצוב ואסתטיקה:</span> גדר יכולה לשדרג את המראה
                        של החצר וליצור אסתטיקה מיוחדת.
                        <br />
                    </p>
                </li>
                <li>
                    <img src={deckImage} alt="דקים" />
                    <h2 data-aos="fade-up">דקים</h2>
                    <p data-aos="fade-up">
                        <span>דקים</span> הם פתרון עיצובי ופונקציונלי פופולרי
                        לחצרות וגינות.
                        <br />
                        אנו מתמחים ביצירת <span>דקים מותאמים אישית</span> לחלל
                        וללב הלקוח.
                        <br />
                        הדקים שלנו מגיעים{" "}
                        <span>במגוון רחב של צבעים, סגנונות ועיצובים</span>.
                        <br />
                        <span>אנו איתכם בכל שלב</span> של התהליך ויוצרים יחד
                        איתכם את הדק המושלם לחצר שלכם.
                        <br />
                    </p>
                </li>
            </ul>
            <a href="#contact" className="animated-button">
                <svg
                    viewBox="0 0 24 24"
                    className="arr-2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
                <span className="text">צור קשר</span>
                <span className="circle"></span>
                <svg
                    viewBox="0 0 24 24"
                    className="arr-1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
            </a>
        </section>
    );
};

export default Services;
